var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        height: "100%",
        "content-class": "contests-switch-alias-dialog"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("span", { staticClass: "contest-info-name-details--usericon" }),
      _vm._v(" "),
      _c("p", { staticClass: "switch-alias--title" }, [
        _vm._v(_vm._s(_vm.$t("Contests.Switch.Alias.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "text-gray",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("Contests.Switch.Alias.Info.No", {
              numberOfContestEntries: _vm.numberOfContestEntries
            })
          )
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "contest-bold" }, [
        _vm._v(_vm._s(_vm.contestName))
      ]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.contestEntries, function(entry) {
          return _c(
            "li",
            {
              key: entry.contestEntryId,
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "contest-alias--link",
                  attrs: {
                    to: {
                      name: "contests/my-picks",
                      params: {
                        contestId: entry.contest.id,
                        contestEntryId: entry.contestEntryId
                      }
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(entry.alias) + "\n      ")]
              )
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd531c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd531c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestsSwitchAliasDialog.vue
// module id = null
// module chunks = 